import React from "react";
import PropTypes from "prop-types";

import DisabledOverlay from "../grundelemente/DisabledOverlay";

import ApplyDismiss from "./ApplyDismiss";
import RadioControl, { RadioOption } from "./RadioControl";
import SelectControl, { SelectOption } from "./SelectControl";
import { saveSettings } from "./SaveSettings";
import { isOk, stateFromModel, modelFromLocal, changeState, recheckState,
	validateNumber } from "./SettingsValue";
import StringControl from "./StringControl";

import "./Druck.css";

const default_local = {
	orientation: null,
	paper_size: null,
	left_margin: null,
	top_margin: null,
	right_margin: null,
	bottom_margin: null,
	image_resolution: null
};

class Druck extends React.Component {

	static propTypes = {
		print: PropTypes.object.isRequired,
		auth: PropTypes.object.isRequired
	};

	constructor(props, context) {
		super(props, context);
		this.handleChange = this.handleChange.bind(this);
		this.apply = this.apply.bind(this);
		this.dismiss = this.dismiss.bind(this);
		this.state = this.genState();
	}
	genState() { return stateFromModel(default_local, this.props.print, Druck.validate); }
	apply() {
		let value = modelFromLocal(this.state.local);
		saveSettings("print", value);
	}
	dismiss() {
		this.setState(this.genState());
	}
	static validate(local) {
		const number_props = [ "left_margin", "top_margin", "right_margin",
			"bottom_margin", "image_resolution" ];
		for (let prop of number_props) {
			if (!isOk(validateNumber(local, prop))) {
				return false;
			}
		}
		return true;
	}
	handleChange(e) {
		this.setState(changeState(e.target.name, e.target.value, this.state, Druck.validate));
	}
	componentWillReceiveProps(nextProps) {
		let change = recheckState(this.state, nextProps.print, Druck.validate);
		if (change) {
			this.setState(change);
		}
	}
	render() {
		return (
			<div className="Druck">
				<DisabledOverlay disabled={!this.props.auth.canWrite} />
				<form>
					<RadioControl i18n_key="Orientation" prop="orientation" local={this.state.local}>
						<RadioOption i18n_key="Landscape" prop="orientation" value="landscape"
							local={this.state.local} handleChange={this.handleChange} />
						<RadioOption i18n_key="Portrait" prop="orientation" value="portrait"
							local={this.state.local} handleChange={this.handleChange} />
					</RadioControl>
					<SelectControl i18n_key="Paper size" prop="paper_size"
						local={this.state.local} handleChange={this.handleChange}>
						<SelectOption value="a4" i18n_key="A4" />
						<SelectOption value="letter" i18n_key="Letter" />
					</SelectControl>
					<StringControl i18n_key="Left margin" prop="left_margin"
						validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />
					<StringControl i18n_key="Top margin" prop="top_margin"
						validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />
					<StringControl i18n_key="Right margin" prop="right_margin"
						validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />
					<StringControl i18n_key="Bottom margin" prop="bottom_margin"
						validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />
					{/* beim export ueber canvas->png gibts keine direkte dpi angabe. also, erstmal irnorieren
						<StringControl i18n_key="Image resolution" prop="image_resolution"
						validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />*/}
				</form>
				<ApplyDismiss state={this.state} apply={this.apply} dismiss={this.dismiss} />
			</div>
		);
	}
}

export default Druck;
